import React from "react";
import { API } from "@/lib/api";

const CAT_GRAD = {
  kerja: "from-blue-500/30 to-slate-900",
  uang: "from-emerald-500/30 to-slate-900",
  relasi: "from-pink-500/30 to-slate-900",
  diri: "from-violet-500/30 to-slate-900",
  keputusan: "from-amber-400/30 to-slate-900",
};

export function CharacterVisual({ icon, name, imageUrl, image, status, category = "keputusan", className = "", forCard = false }) {
  const src = image || (imageUrl ? `${process.env.REACT_APP_BACKEND_URL}${imageUrl}` : null);
  const grad = CAT_GRAD[category] || CAT_GRAD.keputusan;

  if (src) {
    return (
      <div className={`relative overflow-hidden ${className}`} data-testid="character-visual-image">
        <img
          src={src}
          alt={name}
          crossOrigin="anonymous"
          className="w-full h-full object-cover animate-fade"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19] via-transparent to-transparent" />
      </div>
    );
  }

  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-br ${grad} flex flex-col items-center justify-center ${className}`}
      data-testid="character-visual-placeholder"
    >
      <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_50%_30%,rgba(229,193,88,0.35),transparent_60%)]" />
      <div className={`relative z-10 text-center px-6 ${status === "pending" ? "" : ""}`}>
        <div className="text-7xl sm:text-8xl mb-3 animate-float drop-shadow-[0_8px_24px_rgba(0,0,0,0.5)]">{icon}</div>
        <div className="font-display text-2xl sm:text-3xl gold-text tracking-wide">{name}</div>
        {status === "pending" && !forCard && (
          <div className="mt-4 mx-auto w-40 h-1.5 rounded-full overflow-hidden bg-white/10">
            <div className="h-full w-full shimmer" />
          </div>
        )}
        {status === "pending" && !forCard && (
          <p className="mt-2 text-xs text-amber-200/70 font-mono">melukis karakter lo...</p>
        )}
      </div>
    </div>
  );
}
